import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { IFolder } from '../interfaces/folder/ifolder';

@Injectable({
  providedIn: 'root',
})
export class FolderService {
  constructor(private http: HttpClient) {}

  getAll() {
    return this.http.get('https://api-fake-r9p5.onrender.com/folders') as Observable<
      IFolder[]
    >;
    // .pipe(map((res: any) => res['hydra:member'])) as Observable<IFolder[]>;
  }

  save(req: IFolder) {
    return this.http.post(
      'https://api-fake-r9p5.onrender.com/folders',
      req
    ) as Observable<IFolder>;
  }

  edit(req: IFolder, id: number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/merge-patch+json',
    });
    return this.http.patch(`https://api-fake-r9p5.onrender.com/folders/${id}`, req, {
      headers: headers,
    }) as Observable<IFolder>;
  }

  delete(id: number) {
    return this.http.delete(
      `https://api-fake-r9p5.onrender.com/folders/${id}`
    ) as Observable<IFolder>;
  }
}
